"use client";

import { cn } from "@workspace/ui/lib/utils";
import type { ComponentPropsWithoutRef, Ref } from "react";
import { Icons } from "@/components/icons";

type MarketplaceJobMarkerLabelProps = ComponentPropsWithoutRef<"span"> & {
  title: string;
  isFavourited?: boolean;
  /** Phase 5: visually highlights the marker when its row/list item is selected. */
  isActive?: boolean;
  /** Phase 5: visually highlights when its row is hovered. */
  isHovered?: boolean;
  ref?: Ref<HTMLSpanElement>;
};

export function MarketplaceJobMarkerLabel({
  title,
  isFavourited = false,
  isActive = false,
  isHovered = false,
  className,
  ref,
  style,
  ...props
}: MarketplaceJobMarkerLabelProps) {
  return (
    <span
      className={cn(
        "hover:-translate-y-2 relative inline-block min-w-16 cursor-pointer rounded-sm border border-muted-foreground bg-background px-2.5 py-1 text-center text-foreground text-xs shadow-sm transition-[transform,box-shadow] duration-300 hover:shadow-xl focus:outline-none data-[state=open]:z-50 data-[state=open]:shadow-xl",
        isActive && "scale-110 ring-2 ring-ring/60",
        isHovered && "ring-1 ring-ring/40",
        className
      )}
      ref={ref}
      style={{
        transitionTimingFunction: "cubic-bezier(0.16,1,0.3,1)",
        ...style,
      }}
      {...props}
    >
      {title}

      {isFavourited && (
        <span className="-top-3.5 -right-2 absolute rounded-full border bg-background p-1">
          <Icons.heart className="h-3.5 w-3.5 fill-destructive text-destructive" />
        </span>
      )}
    </span>
  );
}
